import React from 'react';
import { MetodeContainer, MetodeWrapper, MetodeH2, MetodeP } from './Style';
import { Typography } from '@material-ui/core';

const About = ({refAbout}) => {
    return (
        <main ref={refAbout}>
        <MetodeContainer>
            <MetodeWrapper>
            <MetodeH2>Mudah Membeli Oleh-Oleh Dengan Kami</MetodeH2>
                <MetodeP><Typography>Toko Oleh-Oleh merupakan salah satu situs jual beli online Oleh-Oleh Khas Bangka Belitung yang bertujuan 
                    untuk memudahkan setiap masyarakat di Indonesia dalam Pembelian Oleh-Oleh khas Bangka Belitung, agar pembelian oleh-oleh dapat secara online. 
                    user dapat mencari dan membeli oleh-oleh khas bangka belitung pada website oleh-oleh khas bangka belitung, 
                    oleh-oleh khas bangka belitung yang tersedia pada website ini hanya jenis snack saja seperti kerupuk, kericu dan kemplang.</Typography></MetodeP>
            </MetodeWrapper>
        </MetodeContainer>
        </main>
    )
}

export default About
